import type { QueryParam } from "@ceeferenderer/itg-renderer-sdk";
import { templateFlowEngine } from "../constants/elements";
import { itgExecution } from "./itgExecution";
import { queryParam } from "./queryParam";
import { Response } from "./handleResponse";

const templateString = templateFlowEngine.innerHTML;
export const transform = async (data?: Partial<QueryParam>, accessToken?: string): Promise<Response> =>
  itgExecution.transform(
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      query: {
        ...queryParam,
        ...(data && {
          displayFormReferenceKey: data.displayFormReferenceKey,
          sessionId: data?.sessionId,
          stepId: data?.stepId,
          ...data[data?.displayFormReferenceKey],
        }),
      },
    },
    templateString,
    true
  );
